// Copyright (c) 2020-2021, 2023 Visual Intelligence LP. All rights reserved.
//
import {GRID_TEAM_COLUMN_NAMES} from '@shared/constants/job-request';
export const REQUEST_PARAMS = {
  filtering: {
    name: 'filtering',
    fields: {
      searchKeyword: 'searchKeyword',
      activityFilter: 'activityFilter',
      isBlocked: 'isBlocked',
      enabled: 'enabled',
      customerId: 'customerId',
      dateRange: 'dateRange',
    }
  },
  sorting: {
    name: 'sorting'
  },
  pagination: {
    name: 'pagination',
    fields: {
      page: 'page',
      pageSize: 'pageSize',
    }
  },
  flag: 'flag'
};

export enum SortingType {
  asc = 'asc',
  desc = 'desc'
}

export enum ActivityFilter {
  active = 'active',
  all = 'all'
}

export const REPORT_PARAMS = {
  assetInfo: {
    siteCode: 'siteCode',
    legacyIdCode: 'legacyIdCode',
    site: 'site',
    state: 'state',
    latitude: 'latitude',
    longitude: 'longitude',
    siteType: 'siteType',
    towerType: 'towerType',
    towerHeight: 'towerHeight',
    multiTower: 'multiTower',
    region1or2: 'region1or2',
    structuralPriority: 'structuralPriority',
    deliveredDate: 'deliveredDate',
    oTIQLinks: 'oTIQLinks',
  },
  po: {
    pONumber: 'pONumber',
    flightPOStatus: 'flightPOStatus',
    groundPOStatus: 'groundPOStatus',
    canceledBy: 'canceledBy',
    cancelNotes: 'cancelNotes',
  },
  staffs: {
    flightCollectionPilot: 'flightCollectionPilot',
    flightCollectionVO: 'flightCollectionVO',
    refly: 'refly',
    groundCollectionTeam: 'groundCollectionTeam',
  },
  deliverables: {
    flightCollection: 'flightCollection',
    geotag: 'geotag',
    towerProfileImages: 'towerProfileImages',
    siteSeeObj: 'siteSeeObj',
    blockXml: 'blockXml',
    accessRoadVideo: 'accessRoadVideo',
    gatesSignageImages: 'gatesSignageImages',
    electricalsFeedlinesImages: 'electricalsFeedlinesImages',
    towerBaseE57Images: 'towerBaseE57Images',
    powerMetersBreakerBoxesImages: 'powerMetersBreakerBoxesImages',
    liDARE57Model: 'liDARE57Model',
    rackElectronicsImages: 'rackElectronicsImages',
    interiorBreakerBoxImages: 'interiorBreakerBoxImages',
    orbitGtPublish: 'orbitGtPublish',
    siteSeeTransfer: 'siteSeeTransfer',
    //acceptanceForCrewPayment: 'acceptanceForCrewPayment',
    fieldQC: 'fieldQC',
    at: 'at',
    atControl: 'atControl',
    threeSm: 'threeSm',
    atCloneSubsample: 'atCloneSubsample',
    orbitGtLinkOtiq: 'orbitGtLinkOtiq',
    siteSeeXml: 'siteSeeXml',
    orbitGtImport: 'orbitGtImport',
    orbitGtOptimize: 'orbitGtOptimize',
    orbitGtUpload: 'orbitGtUpload',
    aiObj: 'aiObj',
    bLK360LeicaProcessingFTP: 'bLK360LeicaProcessingFTP',
    bLK360FTP: 'bLK360FTP',
    bLK360OGT: 'bLK360OGT',
    //bLK360OGTPublish: 'bLK360OGTPublish',
    ai3dTiles: 'ai3dTiles',
    ply1Cm: 'ply1Cm',
    controlManual: 'controlManual',
    lasOpc: 'lasOpc',
    orbitGtExport: 'orbitGtExport',
    sendFlightCollection: 'sendFlightCollection',
    receiveFlightCollection: 'receiveFlightCollection',
    createProjectFolder: 'createProjectFolder',
    verifyFlightCollection: 'verifyFlightCollection',
    sortFlightCollection: 'sortFlightCollection',
    uploadToProcessingClusters: 'uploadToProcessingClusters',
    uploadTowerProfileAndAccessVideo: 'uploadTowerProfileAndAccessVideo',
    inventorySortAndUploadGroundImages: 'inventorySortAndUploadGroundImages',
    liDARCollection: 'liDARCollection',
    e57Upload: 'e57Upload',
    siteSee3dTile: 'siteSee3dTile',
    task1SOWFlightCollect: 'task1SOWFlightCollect',
    task2AIMLDelivered: 'task2AIMLDelivered',
    task3SOWGroundCollect: 'task3SOWGroundCollect',
  },
  jobRequest: {
    status: 'jobRequestStatus',
    teamNumber: 'teamNumber',
    [GRID_TEAM_COLUMN_NAMES.teamName]: GRID_TEAM_COLUMN_NAMES.teamName,
    vehicleInfo: 'vehicleInfo',
    teamEmail: 'teamEmail',
  },
  visitInfo: {
    visitSite: 'visitSite',
    visitRegion: 'visitState',
    visitLatitude: 'visitLatitude',
    visitLongitude: 'visitLongitude',
    visitSiteType: 'visitSiteType',
    visitTowerType: 'visitTowerType',
    visitTowerHeight: 'visitTowerHeight'
  },
  workflow: {
    poReceived: 'poReceived',
    flightPermitSubmitted: 'flightPermitSubmitted',
    flightPermitApproved: 'flightPermitApproved',
    plannedDroneFlight: 'plannedDroneFlight',
    actualDroneFlight: 'actualDroneFlight',
    dataUploadedToServers: 'dataUploadedToServers',
    threeDModelProcessed: 'threeDModelProcessed',
    otiqAiProcessed: 'otiqAiProcessed',
    measurementExtraction: 'measurementExtraction',
    drawingCompleted: 'drawingCompleted',
    StructureAnalysis: 'structureAnalysis',
    reportSubmitted: 'reportSubmitted',
    siteAccepted: 'siteAccepted',
    siteInvoiceSubmitted: 'siteInvoiceSubmitted',
  }
};